import type { WhatsappModalFormValues } from '@presentation/components';
import { getDatabase, ref, set } from 'firebase/database';
import dayjs from 'dayjs';
import { getApps } from 'firebase/app';
import { initializeFirebase } from '@application/firebase';
import { customAlphabet } from 'nanoid';

// USED TEMPORARILY TO GATHER DATA ABOUT WHATSAPP MODAL
const nanoid = customAlphabet('1234567890abcdef', 16);

export const addWhatsappData = async (
  proId: number,
  values: WhatsappModalFormValues,
  resource: 'pro' | 'breeder',
) => {
  const isoTimestamp = dayjs().toISOString();

  if (!getApps().length) {
    initializeFirebase();
  }
  const id = nanoid();
  const db = getDatabase();
  return set(ref(db, `${resource}/${proId}/${id}`), {
    email: values.email ?? null,
    message: values.message ?? null,
    firstName: values.firstName ?? null,
    lastName: values.lastName ?? null,
    phone: values.phone ?? null,
    phonePrefixCountry: values.phonePrefixCountry ?? null,
    marketingEmailConsent: values.marketingEmailConsent ?? null,
    isoTimestamp,
  });
};
